/* eslint-disable no-underscore-dangle */
/**
 * weblog
 * https://weblog.pages.woa.com/#init
 */
import config, { EnterPriseType } from '@src/slide/infrastructure/module/dependent/config/tob/enterprise-config';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { RUNTIME } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { getQuery } from 'sutils';

// 企微文档PPT的PID 详见：http://weblog2.oa.com/#/app/project
const PID = config.supportEnterprise(EnterPriseType.ALL) ? 39 : 11;

// 每次访问的最大日志数量，默认 10000
const MAX_COUNT = 20000;

/**
 * 给log设置加载失败托底
 */
const setDefaultWebLog = () => {
    if (window.log) {
        return;
    }
    const log = {};
    ['info', 'debug', 'error', 'warn', 'report', 'init', 'identify'].forEach((p) => {
        log[p] = () => {};
    });
    window.log = log;
};

/**
 * weblog初始化
 */
const weblogInit = async (): Promise<void> => {
    if (!window) {
        return;
    }

    const options = {
        sdkUrl: RUNTIME.LIBRARY.WEBLOG_BROWSER,
        release: window.__DWS_INFO__?.releaseVersion || global.__globalReleaseVersion,
        maxCount: MAX_COUNT,
    };

    // 兜底log-proxy加载失败
    setDefaultWebLog();

    // 初始化
    await window.log?.init?.(PID, options);

    // 非生产环境打印日志
    if (ENV.IS_TEST || __IS_DEV__) {
        if (getQuery('hideWeblog')) {
            window.log.hideConsole();
        } else {
            window.log.showConsole();
        }
    }
};

/**
 * weblog设置用户uid
 * @param uid
 */
export const weblogIdentity = (uid: string): void => {
    if (!window) {
        return;
    }

    window.log.identify(uid);
};

// 立即执行weblog初始化
weblogInit().then();
